import { UseQueryResult } from "@tanstack/react-query";
import { createContext, useContext } from "react";
import { DealerEstimateContextType } from "../types/DealerEstimateContextType";
import { DealerEstimateDetails } from "../types/DealerEstimateDetails";

enum RefetchScope {
	Files,
	Notes
}

const EstimateContext = createContext<{
	order: DealerEstimateContextType,
	modifyOrder: (details: DealerEstimateDetails) => void
	refetchOrder: (scope?: RefetchScope) => Promise<UseQueryResult>
}>
	({
		order: {} as DealerEstimateContextType,
		modifyOrder: () => { },
		refetchOrder: (scope?: RefetchScope) => { return new Promise(() => { }); }
	});

const useEstimate = () => useContext(EstimateContext);

export { EstimateContext, useEstimate, RefetchScope }
